import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Bromeli - Kertészeti Tanácsadó Blog</title>
        <meta name="description" content="Bromeli kertészeti blog - szakértői tanácsok, növényápolási tippek, fenntartható kertészeti megoldások és szezonális kerti kalauz." />
      </Helmet>

      <div className="terms-conditions-container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', lineHeight: '1.8' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#2d5a27' }}>Általános Szerződési Feltételek</h1>
      
      <p style={{ marginBottom: '20px' }}>Hatályos: 2024. január 1.</p>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>1. A Szolgáltató adatai</h2>
        <p><strong>Szolgáltató:</strong> Bromeli Kft.<br/>
        <strong>Székhely:</strong> 1011 Budapest, Fő utca 1.<br/>
        <strong>Cégjegyzékszám:</strong> 01-09-123456<br/>
        <strong>Adószám:</strong> 12345678-2-41<br/>
        <strong>E-mail:</strong> <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a><br/>
        <strong>Telefon:</strong> +36 1 234 5678<br/>
        <strong>Weboldal:</strong> https://bromeli.com</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>2. A szolgáltatás tárgya</h2>
        <p>A Bromeli kertészeti tanácsadó blog kertészeti témájú tartalmakat, növényápolási tippeket, fenntartható kertészeti megoldásokat és szezonális kerti kalauzokat nyújt. A Weboldal használata ingyenes, kivéve a külön jelölt fizetős szolgáltatásokat.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>3. A Weboldal használatának feltételei</h2>
        <p>A Weboldal használatával Ön elfogadja jelen ÁSZF-et. A Weboldal használatához szükséges:</p>
        <ul>
          <li>Internetkapcsolat</li>
          <li>Megfelelő böngésző program</li>
          <li>Regisztráció (egyes szolgáltatásokhoz)</li>
          <li>Nagykorúság (18 év feletti életkor)</li>
        </ul>
        <p>Ön vállalja, hogy a regisztráció során megadott adatok pontosak és valósak. A felhasználói fiókja biztonságáért Ön felelős.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>4. Szellemi tulajdon</h2>
        <p>A Weboldalon található összes tartalom (szövegek, képek, videók, grafikák, logók, védjegyek) a Bromeli Kft. szellemi tulajdonát képezi, vagy a Szolgáltató engedélyével kerül felhasználásra. A tartalmak bármilyen formában történő másolása, terjesztése, módosítása vagy újrahasznosítása kizárólag a Szolgáltató előzetes írásbeli hozzájárulásával lehetséges.</p>
        <p>A Weboldalon megjelenő felhasználói tartalmak (kommentek, hozzászólások) a felhasználó szellemi tulajdonát képezik, azonban a Szolgáltató jogosult azokat a Weboldalon megjeleníteni és felhasználni.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>5. Regisztráció és felhasználói fiók</h2>
        <p>Egyes szolgáltatások igénybevételéhez regisztráció szükséges. A regisztráció során:</p>
        <ul>
          <li>Érvényes e-mail címet kell megadni</li>
          <li>Felhasználónevet és jelszót kell választani</li>
          <li>El kell fogadni az ÁSZF-et és az Adatvédelmi Szabályzatot</li>
        </ul>
        <p>A felhasználó felelős fiókja biztonságáért. A Szolgáltató nem felel a jogosulatlan hozzáférésből eredő károkért, kivéve, ha az a Szolgáltató hibájából történt.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>6. Fizetős szolgáltatások</h2>
        <p>Bizonyos szolgáltatások (pl. prémium tartalmak, konzultációk) fizetősek lehetnek. A fizetős szolgáltatások igénybevételének feltételei:</p>
        <ul>
          <li>Az árak az általános forgalmi adót (ÁFA) tartalmazzák</li>
          <li>A fizetés bankkártyával vagy banki átutalással történhet</li>
          <li>A fizetési tranzakciókat biztonságos fizetési szolgáltatók kezelik</li>
          <li>A szolgáltatás igénybevételének megkezdése után a fizetési kötelezettség fennáll</li>
        </ul>
        <p>A Szolgáltató fenntartja a jogot az árak módosítására, azonban a módosítás nem érinti a már megkötött szerződéseket.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>7. Felhasználói magatartás</h2>
        <p>A Weboldal használata során Ön köteles:</p>
        <ul>
          <li>Tiszteletben tartani más felhasználók jogait</li>
          <li>Nem megsértő, nem rágalmazó, nem gyűlöletkeltő tartalmakat közzétenni</li>
          <li>Nem megszegni a hatályos jogszabályokat</li>
          <li>Nem jogosulatlanul hozzáférni más felhasználók adataihoz</li>
          <li>Nem terjeszteni vírusokat vagy más káros szoftvereket</li>
          <li>Nem folytatni spam vagy adathalász tevékenységet</li>
        </ul>
        <p>A Szolgáltató jogosult a szabályokat megszegő felhasználók hozzáférését felfüggeszteni vagy megszüntetni.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>8. A Szolgáltató felelőssége</h2>
        <p>A Szolgáltató nem vállal felelősséget:</p>
        <ul>
          <li>A Weboldal rendelkezésre állásáért (karbantartás, technikai hibák esetén)</li>
          <li>A felhasználók által közzétett tartalmak helyességéért</li>
          <li>A kertészeti tanácsok alkalmazásából eredő károkért</li>
          <li>Külső linkek tartalmáért</li>
          <li>Vis maior eseményekből eredő károkért</li>
        </ul>
        <p>A Szolgáltató felelőssége kizárólag a szándékos vagy súlyosan gondatlan magatartásból eredő károkra terjed ki.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>9. A szerződés megszűnése</h2>
        <p>A Szolgáltató jogosult a felhasználói fiókot felfüggeszteni vagy megszüntetni, ha a felhasználó megszegi az ÁSZF-et vagy a hatályos jogszabályokat. A felhasználó bármikor törölheti fiókját, vagy leiratkozhat a szolgáltatásokról.</p>
        <p>A fizetős szolgáltatások esetén a szerződés megszűnése nem mentesít a már esedékes fizetési kötelezettségek alól.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>10. Elállási jog (fogyasztóvédelmi rendelkezések)</h2>
        <p>Fogyasztónak minősülő felhasználó esetén a 45/2014. (II. 26.) Korm. rendelet alapján:</p>
        <ul>
          <li>Az elállási jog 14 napig gyakorolható a szolgáltatás megrendelésétől számítva</li>
          <li>Digitális tartalom esetén, ha a szolgáltatás azonnali teljesítését kéri, az elállási jog megszűnik a teljesítés megkezdésével</li>
          <li>Az elállási nyilatkozatot az <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a> e-mail címre kell elküldeni</li>
        </ul>
        <p>Az elállás esetén a befizetett összeget 14 napon belül visszatérítjük, kivéve, ha a szolgáltatás már teljesítésre került.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>11. Panaszkezelés</h2>
        <p>Ha panasz merül fel a szolgáltatással kapcsolatban, kérjük, írjon az <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a> e-mail címre. A panaszt 30 napon belül kivizsgáljuk és írásban válaszolunk.</p>
        <p>Fogyasztóvédelmi eljárás keretében a felhasználó fordulhat a:</p>
        <ul>
          <li>Fogyasztóvédelmi Hatósághoz (https://fogyasztovedelem.kormany.hu)</li>
          <li>Békéltető Testülethez (Budapesti Békéltető Testület: 1016 Budapest, Krisztina krt. 99.)</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>12. Jogviták rendezése</h2>
        <p>A jelen ÁSZF-re a magyar jog az irányadó. A felek a jogvitákat elsődlegesen egyeztetéssel kísérlik meg rendezni. Amennyiben az egyeztetés nem vezet eredményre, a jogvita eldöntésére a Szolgáltató székhelye szerinti bíróság rendelkezik illetékességgel.</p>
        <p>Az Európai Bizottság online vitarendezési platformja: https://ec.europa.eu/consumers/odr</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>13. Külső linkek</h2>
        <p>A Weboldal külső weboldalakra mutató linkeket tartalmazhat. A Szolgáltató nem vállal felelősséget ezen weboldalak tartalmáért és adatvédelmi gyakorlatáért. A külső weboldalak használata előtt javasoljuk azok adatvédelmi szabályzatának megismerését.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>14. Az ÁSZF módosítása</h2>
        <p>A Szolgáltató fenntartja a jogot, hogy jelen ÁSZF-et bármikor módosítsa. A módosítások a Weboldalon történő közzététellel lépnek hatályba. A felhasználók e-mailben értesítést kapnak a jelentős változásokról.</p>
        <p>Ha a felhasználó nem fogadja el a módosított ÁSZF-et, jogosult a szolgáltatás használatát megszüntetni.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>15. Vegyes rendelkezések</h2>
        <ul>
          <li>Az ÁSZF egyes pontjainak érvénytelensége nem érinti a többi pont érvényességét</li>
          <li>A Szolgáltató jogosult a szolgáltatásokat harmadik félnek átruházni</li>
          <li>Az ÁSZF-ben nem szabályozott kérdésekben a magyar jogszabályok az irányadók</li>
          <li>A felhasználó és a Szolgáltató közötti kommunikáció elektronikus úton történik</li>
        </ul>
      </section>
      
      <footer style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #ccc', textAlign: 'center', color: '#666' }}>
        <p>© 2024 Bromeli Kft. Minden jog fenntartva.</p>
      </footer>
    </div>
  
    </>);
};

export default TermsConditions;